import request from '../request'
import apis from '../apis'

export default {

    /**
     * 展会配置首页列表
     * @param {*} param
     */
    getExhiIndexList({ param, pageVO }) {
        return request.get(`${apis.GET_EXHI_INDEX_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params: param });
    },

    /**
     * 展会推荐开关
     * @param {*} param
     */
    changeExhiSwitch({ param }) {
        return request.get(`${apis.CHANGE_EXHI_SWITCH}`, { params: param });
    },

    /**
     * 展会是否可见
     * @param {*} param
     */
    changeExhiVisible(param) {
        return request.get(`${apis.CHANGE_EXHI_VISIBLE}`, { params: param });
    },

    /**
     * 展会编辑页
     * @param {*} param
     */
    editExhiInfo({ param }) {
        return request.get(`${apis.EDIT_EXHI_INFO}`, { params: param });
    },

    /**
     * 新增展会
     * @param {*} param
     */
    addExhi(param) {
        return request.post(`${apis.ADD_EXHI}`, param)
    },

    /**
     * 编辑展会
     * @param {*} param
     */
    editExhi(param) {
        return request.post(`${apis.EDIT_EXHI}`, param)
    },

    /**
     * 编辑展会信息
     * @param {*} param0
     */
    getEditExhiInfo(param) {
        return request.get(`${apis.GET_EDIT_EXHI_INFO}`, { params: param });
    },

    /**
     * 锁类型
     * @param {*} param0
     */
    lockType(param) {
        return request.get(`${apis.PUBLIC_LOCK_REQ_TYPE}`, { language: param });
    },

    /**
     * 展会是否可见 lookUp
     * @param {*} param0
     */
    getIsVisible({ param }) {
        return request.get(`${apis.GET_IS_VISIBLE}`)
    },

    /**
     * 弹出cims展会收索页
     * @param {*} param0
     */
    searchCimsExhiList({ param, pageVO }) {
        return request.get(`${apis.SEARCH_CIMS_EXHI_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params: param });
    },

    /**
     * cims 展会详情
     * @param {*} param0
     */
    getCimsExhiDetail(param) {
        return request.get(`${apis.GET_CIMS_EXHI_DETAIL}`, { params: param });
    },

    /**
     * 展会导出
     * @param {*} param
     */
    exportList(param) {
        return request.get(`${apis.EXPORT_LIST}`, { params: param });
    }
}
